module.exports = __webpack_public_path__ + "img/bell.f008ca9b.svg";